import React from 'react';
import './HomePage.scss';
import MusicalNetworks from '../../components/MusicalNetworks/MusicalNetworks';
import DividedSection from '../../components/DividedSection/DividedSection';

const Lanzamiento = () => {
    return (
        <iframe
            data-testid="embed-iframe"
            style={{ borderRadius: "18px" }}
            src="https://open.spotify.com/embed/track/1RKLRe7Aikf5lQIihw8CdX?utm_source=generator"
            width="352"
            height="352"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            loading="lazy"
            title="Spotify Player"
        />
    )
}

const HomePage = () => {
    return (
        <div className='home-block'>
            <div className="home__hero1">
            </div>
            <div className="home__hero2">
                <div className="home__column">
                    <h2 className="home__title">🔥¡Escúchala ya!🔥:</h2>
                    <Lanzamiento />
                </div>
                <div className="home__column2">
                    <div>
                        <h2 className="home__title">¡Nuevo Lanzamiento!</h2>
                        <h4 className="home__subtitle">
                            Disponible en las siguientes plataformas, descárgalo y escúchalo ya:
                        </h4>
                    </div>
                    <MusicalNetworks />
                </div>
            </div>
        </div>
    )
}

export default HomePage